(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hwd-mobile-purchase-bar"] && !Shopify.designMode) return;
  try {
    const initHwdMobilePurchaseBars = (scope = document) => {
    scope.querySelectorAll('[data-hwd-mobile-purchase-bar]').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;

      const sectionId = bar.dataset.sectionId;
      const primaryButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const priceRoot = document.getElementById(`price-${sectionId}`);
      const stickyButton = bar.querySelector('[data-hwd-sticky-submit]');
      const stickyLabel = bar.querySelector('[data-hwd-sticky-label]');
      const stickyPrice = bar.querySelector('[data-hwd-sticky-price]');

      if (!primaryButton || !stickyButton) return;

      document.body.append(bar);
      bar.dataset.initialized = 'true';

      const updateBarHeight = () => {
        document.documentElement.style.setProperty(
          '--hwd-mobile-purchase-bar-height',
          `${Math.ceil(bar.getBoundingClientRect().height)}px`
        );
      };

      const updateBodySpacing = () => {
        document.body.classList.toggle(
          'hwd-mobile-purchase-bar-active',
          Boolean(document.querySelector('[data-hwd-mobile-purchase-bar].is-visible'))
        );
      };

      const updateVisibility = () => {
        const rect = primaryButton.getBoundingClientRect();
        const primaryIsVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        const shouldShow = window.innerWidth < 750 && window.scrollY > 160 && !primaryIsVisible;
        bar.classList.toggle('is-visible', shouldShow);
        if (shouldShow) updateBarHeight();
        updateBodySpacing();
      };

      const updateButton = () => {
        const sourceLabel = primaryButton.querySelector('span');
        stickyButton.disabled = primaryButton.disabled;
        if (sourceLabel && stickyLabel) stickyLabel.textContent = sourceLabel.textContent.trim();
      };

      const updatePrice = () => {
        if (!priceRoot || !stickyPrice) return;
        const sourcePrice =
          priceRoot.querySelector('.price__sale .price-item--sale') ||
          priceRoot.querySelector('.price__regular .price-item--regular') ||
          priceRoot.querySelector('.price-item');
        if (sourcePrice) stickyPrice.textContent = sourcePrice.textContent.trim();
      };

      stickyButton.addEventListener('click', () => {
        if (primaryButton.disabled) {
          const productInfo = primaryButton.closest('product-info');
          const variantPicker = productInfo?.querySelector('variant-selects, variant-radios, select');
          (variantPicker || primaryButton).scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        primaryButton.click();
      });

      new MutationObserver(updateButton).observe(primaryButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      if (priceRoot) {
        new MutationObserver(updatePrice).observe(priceRoot, { childList: true, subtree: true });
      }

      new ResizeObserver(updateBarHeight).observe(bar);

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateButton();
      updatePrice();
      updateVisibility();
    });
  };

  initHwdMobilePurchaseBars();
  document.addEventListener('shopify:section:load', (event) => initHwdMobilePurchaseBars(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    document
      .querySelectorAll(`[data-hwd-mobile-purchase-bar][data-section-id="${event.detail.sectionId}"]`)
      .forEach((bar) => bar.remove());
    if (!document.querySelector('[data-hwd-mobile-purchase-bar]')) {
      document.body.classList.remove('hwd-mobile-purchase-bar-active');
      document.documentElement.style.removeProperty('--hwd-mobile-purchase-bar-height');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
